export default [
  {
    path: '/reverse-order',
    name: 'ReverseOrder',
    component: () => import('@/layout'),
    redirect: '/reverse-order/refund',
    meta: {
      title: '逆向订单管理',
    },
    children: [
      {
        path: 'refund',
        name: 'reverseOrderRefund',
        component: () => import('@/views/web/reverse-order/refund'),
        meta: {
          title: '退款记录',
          noCache: false,
          auth: true,
          trackCode: 'menu-20',
          trackName: '逆向订单管理 - 退款记录',
          activeMenu: '/reverse-order/refund',
        },
      },
      {
        path: 'supplement',
        name: 'reverseOrderSupplement',
        component: () => import('@/views/web/reverse-order/supplement'),
        meta: {
          title: '补款记录',
          noCache: false,
          auth: true,
          trackCode: 'menu-21',
          trackName: '逆向订单管理 - 补款记录',
          activeMenu: '/reverse-order/supplement',
        },
      },
    ],
  },
];
